import { Button, Card, Col, Form, InputGroup } from 'react-bootstrap';
import './BeAnOwnerFormStepper.scss';
import React, { useState } from 'react';
import AddRemoveButton from '../../../molecules/AddRemoveButton/AddRemoveButton';
import { useFormContext } from 'react-hook-form';
import PhoneInputControlled from '../../../atoms/PhoneInputControlled/PhoneInputControlled';

export interface StepProps {
  nextStep?: Function;
}

function Step03({ nextStep }: StepProps) {
  const {
    register,
    control,
    formState: { errors }
  } = useFormContext();
  return (
    <Card className={'card-stepper'}>
      <Card.Body className={'last-step'}>
        <Card.Subtitle className="mb-2 text-muted mt-3">Step 3 of 3</Card.Subtitle>
        <Card.Title className={'mt-3'}>Thank you for your submission. Your rate estimate along with additional details have been sent to your email.</Card.Title>
      </Card.Body>
    </Card>
  );
}

export default Step03;
